import React, { useMemo, useState } from 'react';

const EMOJI_CATEGORIES = [
  {
    id: 'frequent',
    label: 'Usados frequentemente',
    tab: '🕒',
    emojis: ['😀', '😂', '❤️', '👍', '🔥', '✨', '🎉', '👏', '🙏', '😊', '😍', '🤝'],
  },
  {
    id: 'smileys',
    label: 'Smiles & People',
    tab: '😀',
    emojis: [
      '😀', '😁', '😂', '🤣', '😊', '😇', '🙂', '😉', '😍', '🥰', '😘', '😜',
      '🤔', '😐', '😴', '😮', '😢', '😭', '😤', '🤯', '🥳', '😎', '🤗', '🙌',
    ],
  },
  {
    id: 'nature',
    label: 'Animais & Natureza',
    tab: '🐶',
    emojis: ['🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮', '🐷', '🐸', '🐵', '🦄'],
  },
  {
    id: 'food',
    label: 'Comida & Bebida',
    tab: '🍕',
    emojis: ['🍎', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🍒', '🍑', '🥝', '🍕', '🍔', '🍟', '🍣', '🍩', '☕'],
  },
  {
    id: 'activity',
    label: 'Atividades',
    tab: '⚽',
    emojis: ['⚽', '🏀', '🏈', '⚾', '🎾', '🏐', '🎱', '🏓', '🥊', '⛳', '🏆', '🎯', '🎮', '🎲', '🎸', '🎧'],
  },
  {
    id: 'travel',
    label: 'Viagem',
    tab: '✈️',
    emojis: ['🚗', '🚕', '🚌', '🚎', '🏎️', '🚓', '🚑', '🚒', '✈️', '🚀', '🚁', '⛵', '🏠', '🏢', '🗽', '🗺️'],
  },
  {
    id: 'objects',
    label: 'Objetos',
    tab: '💡',
    emojis: ['⌚', '📱', '💻', '⌨️', '🖥️', '🖨️', '🖱️', '💾', '📷', '📹', '💡', '🔦', '📚', '✏️', '📎', '🔑'],
  },
  {
    id: 'symbols',
    label: 'Símbolos',
    tab: '💜',
    emojis: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '💯', '💢', '💥', '💫', '⭐', '🌟', '✨', '⚡'],
  },
];

export function ComposerEmojiPicker({ onPick, onClose }) {
  const [query, setQuery] = useState('');
  const [activeId, setActiveId] = useState('frequent');

  const sections = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (q) {
      return EMOJI_CATEGORIES.filter((cat) => cat.label.toLowerCase().includes(q));
    }
    return EMOJI_CATEGORIES.filter((c) => c.id === activeId);
  }, [query, activeId]);
  return (
    <div className="bch-emoji-picker" role="dialog" aria-label="Emojis">
      <div className="bch-emoji-picker-head">
        <input
          type="search"
          className="bch-emoji-search"
          placeholder="Pesquisar..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          autoFocus
        />
      </div>
      <div className="bch-emoji-picker-body">
        {sections.length === 0 ? (
          <p className="bch-emoji-empty">Nenhum emoji encontrado</p>
        ) : (
          sections.map((cat) => (
            <div key={cat.id} className="bch-emoji-section">
              <div className="bch-emoji-section-label">{cat.label}</div>
              <div className="bch-emoji-grid">
                {cat.emojis.map((emoji) => (
                  <button
                    key={`${cat.id}-${emoji}`}
                    type="button"
                    className="bch-emoji-item"
                    onClick={() => {
                      onPick?.(emoji);
                      onClose?.();
                    }}
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
      {!query.trim() ? (
        <div className="bch-emoji-tabs" role="tablist" aria-label="Categorias">
          {EMOJI_CATEGORIES.map((cat) => (
            <button
              key={cat.id}
              type="button"
              role="tab"
              aria-selected={activeId === cat.id}
              className={`bch-emoji-tab${activeId === cat.id ? ' is-active' : ''}`}
              title={cat.label}
              onClick={() => setActiveId(cat.id)}
            >
              <span aria-hidden="true">{cat.tab}</span>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
